//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from "../footer/footer.vue";
import Header from "../header/header.vue";
import { Toast } from "vant";
import Multiselect from "vue-multiselect";
import { areaData } from "../../util/areaData";
export default {
  name: "registe",
  data() {
    return {
      nickName: "", // 昵称
      province: null, // 省
      city: null, // 市
      area: null, // 区
      provinceData: areaData, // 省下拉列表
      cityData: [], // 市下拉列表
      areaData: [], // 区下拉列表
      userPhone: "", // 手机号
      smsCode: "", // 验证码
      second: 59, // 倒计时数字
      timeFlag: false, // 验证码开关
      isSamll: 0 // 1366样式
    };
  },
  components: { Header, Footer, Multiselect },
  created () {
    if (window.screen.height <= 768 && window.screen.width <= 1366) {
      this.isSamll = 1
    }
  },
  methods: {
    registerByWx () {
      this.$router.push({ path: "wxScan" });
    },
    fnGoToLoginPage() {
      // 跳转到登录页面
      this.$router.push({ path: "login" });
    },
    fnSendSms() {
      // 发送验证码
      if (this.userPhone == "") {
        Toast("请输入手机号");
        return;
      }
      let param = {
        smsType: 1,
        smsPhone: this.userPhone,
      };
      let checkParam = {
        userPhone: this.userPhone,
      };
      // 校验注册手机号码是否存在
      this.$store
        .dispatch("user/fnCheckPhoneHave", JSON.stringify(checkParam))
        .then((res) => {
          if (res.data.retCode == 1) {
            // 调用发验证码接口
            this.$store
              .dispatch("fnNoCheckSmsSendSmsCode", JSON.stringify(param))
              .then((res) => {
                if (res.data.retCode == 1) {
                  this.fnHandleTimer();
                } else {
                  Toast(res.data.retMsg);
                }
              });
          } else {
            Toast(res.data.retMsg);
          }
        });
    },
    fnHandleTimer() {
      // 处理验证码
      let maxSecond = 60;
      this.timeFlag = true;
      let timer = setInterval(() => {
        if (this.second > 0 && this.second <= maxSecond) {
          this.second--;
        } else {
          this.timeFlag = false;
          this.second = 59;
          clearInterval(timer);
        }
      }, 1000);
    },
    fnConfirm() {
      // 提交
      if (this.fnCheckForm()) {
        let param = {
          nickName: this.nickName,
          userPhone: this.userPhone,
          smsCode: this.smsCode,
          province: this.province.id,
          provinceCode: this.province.areaName,
          city: this.city.id,
          cityCode: this.city.areaName,
          area: this.area.id,
          areaCode: this.area.areaName,
          createType: 0,
          bindWechar: 0,
          realState: 0,
          safetyLevel: 0,
          isLogin: 0
        };
        this.$store
          .dispatch("user/fnRegisterNoCheckDoRegister", JSON.stringify(param))
          .then((res) => {
            if (res.data.retCode == 1) {
              this.fnHandleUser(res.data.obj);
            } else {
              Toast(res.data.retMsg);
            }
          });
      }
    },
    fnCheckForm() { // 验证表单
      if(this.nickName == ''){
        Toast('请输入昵称')
        return false
      }
      if(this.province == null || this.province == {}){
        Toast('请选择省')
      }
      if(this.city == null || this.city == {}){
        Toast('请选择市')
      }
      if(this.area == null || this.area == {}){
        Toast('请选择区')
      }
      if(this.userPhone == ''){
        Toast('请输入手机号')
        return false
      }
      if(this.smsCode == ''){
        Toast('请输入验证码')
        return false
      }
      return true
    },
    fnHandleUser(obj) {
      // 处理注册后用户信息
      // 保存到token中
      this.$store.commit("setUserInfo", obj);
      // 跳转到注册成功页面
      this.$router.push({ path: "registeSuccess" });
    },
    fnHandleCity() {
      // 选择省份后处理城市
      this.city = null;
      this.area = null;
      if(this.province == null) {
        this.cityData = []
      } else {
        this.cityData = this.province.items;
      }
      this.areaData = [];
    },
    fnHandleArea() {
      // 选择城市后处理地区
      this.area = null;
      if(this.city == null) {
        this.areaData = []
      } else {
        this.areaData = this.city.items;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/login/registe.vue